export const MAX_PAGINATION_ITEMS_LENGTH = 8;
